import { withLazyLoad } from '@src/components';
import { lazy, ReactElement } from 'react';
import { Route, Routes } from 'react-router-dom';

const FormsPage = lazy(() => import('~/modules/forms/forms.page'));
const NotFoundPage = lazy(() => import('~/modules/not-found.page'));

/**
 * O token é opcional para que a raiz também caia no formulário.
 *
 * Quem abre `/` sem hash — link truncado pelo cliente de e-mail, URL digitada
 * à mão — recebe o mesmo cartão de link inválido de quem abre uma hash morta,
 * e não um "Página não Encontrada" que parece falha do site. A sessão já trata
 * o token ausente como falha de autenticação; só faltava a rota chegar lá.
 */
const FormsRouter = (): ReactElement => (
  <Routes>
    <Route path='/:token?' element={withLazyLoad(<FormsPage />)} />
    <Route path='*' element={withLazyLoad(<NotFoundPage />)} />
  </Routes>
);

export { FormsRouter };
